import { schema } from 'normalizr'
import moment from 'moment'

import { STATUS_CONFIRMED } from './constants'

export const getRateId = value =>
    [value.rateId, moment(value.fromDateISO).unix(), moment(value.toDateISO).unix(), value.amount].join('-')

export const rateSchema = new schema.Entity('grsRates', undefined, {
    idAttribute: getRateId,
    processStrategy: value => ({
        ...value,
        $rateId: getRateId(value),
        fromDate: moment.parseZone(value.fromDateISO),
        toDate: moment.parseZone(value.toDateISO),
    }),
})

const getId = value => value.id || value.eDataLocationId

export const locationSchema = new schema.Entity(
    'grsLocations',
    {},
    {
        idAttribute: getId,
        processStrategy: value => {
            const { name, description, address1, address2, city, state, zip, phone, lotFromEmail: email } = value

            return {
                id: getId(value),
                name,
                description,
                address1,
                address2,
                city,
                state,
                zip,
                phone,
                email,
            }
        },
    }
)

const reservationProcessor = value => ({
    ...value,
    fromDate: moment.parseZone(value.startDateISO),
    toDate: moment.parseZone(value.endDateISO),
    createdDate: moment.parseZone(value.createdDateISO),
    expiryDate: value.expiryDateISO ? moment.parseZone(value.expiryDateISO) : null,
    isConfirmed: value.status === STATUS_CONFIRMED,
})

export const reservationSchema = new schema.Entity('reservations', undefined, {
    idAttribute: value => value.reservationId || value.waitingListKey,
    processStrategy: reservationProcessor,
})
